// extracted by mini-css-extract-plugin
export default {"detail":"detail_detail__PmJ8l"};